module.exports = __webpack_public_path__ + "static/media/undraw_events_2p66.44fc064e.svg";